import {
  convertFromLocalMachineToUTC,
  subtractTimeZoneOffsetFromDate,
  isFirstDateAfterSecondDateUsingOffsets
} from 'admin/lib/Functions/timeZoneHelper'

const DATE_AFTER_CREATION_DATE_WARNING_MESSAGE =
  'Date is after the Creation Date for this record'
const DATE_LONG_BEFORE_CREATION_DATE_WARNING_MESSAGE =
  'Date is long before the Creation Date for this record'
const EXIT_DATE_BEFORE_ARRIVAL_DATE_WARNING_MESSAGE =
  'Exit date is before the Arrival Date for this record'

export const calculateWarningsForArrivalDate = (
  arrivalDate: string,
  createdAtDate: string | null | undefined,
  projectTimeZone: string
) => {
  const warnings: string[] = []

  // Created At is supposed to be in UTC timezone, but Arrival Date will be in project timezone, so we have
  // to adjust for that in the comparison.
  if (
    createdAtDate &&
    isFirstDateAfterSecondDateUsingOffsets(
      arrivalDate,
      projectTimeZone,
      createdAtDate
    )
  ) {
    warnings.push(DATE_AFTER_CREATION_DATE_WARNING_MESSAGE)
  }

  if (createdAtDate && arrivalDate) {
    // Remove one year from Created At date for comparison
    const createdAtDateObj = new Date(createdAtDate)
    createdAtDateObj.setFullYear(createdAtDateObj.getFullYear() - 1)

    // Created At is supposed to be in UTC timezone, but Arrival Date will be in project timezone, so we have
    // to adjust for that in the comparison.
    const arrivalWithOffsetApplied = subtractTimeZoneOffsetFromDate(
      new Date(arrivalDate),
      projectTimeZone
    )

    // UTC dates are loaded as local machine timezone, so convert back to UTC for comparison
    const createdAtUTC = convertFromLocalMachineToUTC(createdAtDateObj)

    if (arrivalWithOffsetApplied < createdAtUTC) {
      warnings.push(DATE_LONG_BEFORE_CREATION_DATE_WARNING_MESSAGE)
    }
  }

  return warnings
}

export const calculateWarningsForExitDate = (
  exitDate: string,
  arrivalDate: string,
  createdAtDate: string | null | undefined,
  projectTimeZone: string,
  compareExitAndArrivalEvenIfExitBlank = false
) => {
  if (!exitDate && !compareExitAndArrivalEvenIfExitBlank) {
    return []
  }

  const warnings: string[] = []

  // Created At is supposed to be in UTC timezone, but Exit Date will be in project timezone, so we have
  // to adjust for that in the comparison.
  if (
    exitDate &&
    createdAtDate &&
    isFirstDateAfterSecondDateUsingOffsets(
      exitDate,
      projectTimeZone,
      createdAtDate
    )
  ) {
    warnings.push(DATE_AFTER_CREATION_DATE_WARNING_MESSAGE)
  }

  // Arrival and Exit dates are both in project timezone, so just compare directly.
  if (arrivalDate && new Date(arrivalDate) > new Date(exitDate)) {
    warnings.push(EXIT_DATE_BEFORE_ARRIVAL_DATE_WARNING_MESSAGE)
  }

  return warnings
}
